import { DONATION_ROUTES, MODULE_ROUTES } from '@/constants';

type DonationRouteEntry =
  | (typeof DONATION_ROUTES)[keyof typeof DONATION_ROUTES]
  | (typeof MODULE_ROUTES)[keyof typeof MODULE_ROUTES];

export const findDonationRoute = (pathname: string | null) => {
  if (!pathname) return;

  // 키 충돌로 라우트가 누락되지 않도록 값 기반으로 평탄화한다.
  const allRoutes: DonationRouteEntry[] = [
    ...Object.values(DONATION_ROUTES),
    ...Object.values(MODULE_ROUTES),
  ];

  let matchedRoute: { route?: DonationRouteEntry; point: number } = {
    point: 0,
  };

  for (const route of allRoutes) {
    if (typeof route.pathname === 'string') {
      if (route.pathname === pathname) {
        return route;
      }

      continue;
    }

    const isPathFunction = (
      value: unknown,
    ): value is (
      dynamicPath: Record<string, string | number | null | boolean>,
    ) => string => typeof value === 'function';

    const emptyDynamicParams: Record<
      string,
      string | number | null | boolean
    > = {};

    const splitedRoutePathname = isPathFunction(route.pathname)
      ? route.pathname(emptyDynamicParams).split('/')
      : [];
    const splitedCurrentPathname = pathname.split('/');

    if (splitedRoutePathname.length !== splitedCurrentPathname.length) continue;

    let matchPoint = 0;

    const isAllSame = splitedCurrentPathname.every((path, index) => {
      const partOfRoutePathname = splitedRoutePathname[index];

      //! 동적 경로인 경우 더 일치도가 높은 라우트를 설정

      if (partOfRoutePathname === 'undefined') {
        matchPoint += 1;

        return true;
      }

      if (path === partOfRoutePathname) {
        matchPoint += 2;

        return true;
      }

      return false;
    });

    if (isAllSame && matchedRoute.point < matchPoint) {
      matchedRoute = { route, point: matchPoint };
    }
  }

  return matchedRoute.route;
};
